import React from 'react';

interface IProps {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  actions?: React.ReactNode;
}

export const PageTitle: React.FC<IProps> = (props) => {
  return (
    <div className="sm:flex sm:items-center mb-10">
      <div className="sm:flex-auto overflow-hidden">
        <h1 className="text-xl font-bold leading-7 text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight truncate">
          {props.title}
        </h1>
        <div className="mt-2 text-sm text-gray-700">{props.subTitle || ''}</div>
      </div>
      {props.actions ? (
        <div className="flex gap-x-4 mt-4 sm:ml-8 sm:mt-0">{props.actions}</div>
      ) : null}
    </div>
  );
};
